<template>
  <div class="container mt-5">
    <form class="row g-2 col-4 mx-auto">
      <h2 class="text-center">Chat Platform</h2>
      <small v-if="!!error" class="text-danger text-center">{{ error }}</small>
      <f-input v-model="username" label="Логин" w="12"/>
      <f-input v-model="password" label="Пароль" type="password" w="12"/>
      <div class="text-center">
        <button type="submit" class="btn btn-primary px-5 m-1" :disabled="!isValid || isLoading" @click.prevent="signIn">
          <span v-if="isLoading" class="spinner-border spinner-border-sm"></span>
          Войти
        </button>

      </div>
      <small class="text-center">{{ version }}</small>

    </form>
  </div>

</template>

<script>
import FInput from "@/components/FInput";
import {auth} from "@/state/auth";
import {http} from "@/misc/http";
import {version} from "../../../package.json"

export default {
  name: "AuthForm",
  components: {FInput},
  data() {
    return {
      username: '',
      password: '',
      loading: false,
      error: '',
      edit: true,
    }
  },

  computed: {
    version() {
      return version;
    },
    isValid() {
      return this.username && this.password;
    },
    isLoading() {
      return this.loading;
    }
  },


  methods: {
    async signIn() {

      this.loading = true;

      try {
        const resp = await http.post_form("/auth/login", {
          username: this.username,
          password: this.password

        });
        await auth.login(resp.access_token);
        await this.$router.replace({name: "main"});
      } catch (e) {
        this.error = e.message;
      }
      this.loading = false;
    },
  }


}
</script>
